// До React 19 доступ к `element.props.ref` вызовет предупреждение и предложит использовать `element.ref`
// После React 19 доступ к `element.ref` делает противоположное.
// https://github.com/facebook/react/pull/28348
//
// Доступ к ref с использованием метода, который не вызывает предупреждение.
export function getElementRef(element) {
  var _Object$getOwnPropert, _Object$getOwnPropert2;
  // React <=18 в DEV
  var getter = (_Object$getOwnPropert = Object.getOwnPropertyDescriptor(element.props, 'ref')) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.get;
  var mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
  if (mayWarn) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return element.ref;
  }

  // React 19 в DEV
  getter = (_Object$getOwnPropert2 = Object.getOwnPropertyDescriptor(element, 'ref')) === null || _Object$getOwnPropert2 === void 0 ? void 0 : _Object$getOwnPropert2.get;
  mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }

  // Не DEV
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return element.props.ref || element.ref;
}